import { FunctionComponent, ReactNode } from "react";
import { NavLink } from "react-router";

import { Card, Typography } from "@digital-services/ui";

interface Props {
  id: string;
  title: string;
  href: string;
  icon: ReactNode;
}

export const QuickAccessTile: FunctionComponent<Props> = props => {
  const { id, title, href, icon } = props;

  return (
    <NavLink
      to={href}
      key={"nav_" + id}
      style={{ color: "black", textDecoration: "none" }}
      data-testid={`link-${id}`}
    >
      <Card
        className="grid h-32 w-60 grid-cols-1 place-content-center place-items-center gap-4"
        data-testid={`quick-access-tile-card-${id}`}
      >
        <div data-testid="quick-access-tile-image">{icon}</div>
        <Typography variant="smallTitle">{title}</Typography>
      </Card>
    </NavLink>
  );
};
